<template>
  <div>
    <div
      v-if="isLoaded && !error"
      id="intro_wishlist_items"
      :class="{ 'disable-whole-div': isPerformingAction }"
    >
      <div class="d-flex flex-row">
        <template v-if="hasFilterOptions || publicToken">
          <!-- Sidebar -->
          <div
            v-if="hasFilterOptions"
            class="wishlist-sidebar side-bar"
          >
            <shop-filter
              v-if="
                filterOptions.departments && filterOptions.departments.length
              "
              class="mr-1"
              :filters="filters"
              :total-products="totalProducts"
              :filter-options="filterOptions"
              :whole-sale-enable="isShowWsp && wspAllowedForViewer"
              :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
              @update-filters="fetchShopProducts"
              @close-sidebar="closeSideBar"
            />
          </div>

          <!-- ECommerce Header -->
          <div class="pb-0 w-100">
            <div
              class="sticky-search-bar wishlist"
              :class="{ 'pb-0': !isBrand, 'public-full-width': !!publicToken }"
            >
              <section id="ecommerce-header">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="ecommerce-header-items">
                      <div class="result-toggler">
                        <feather-icon
                          icon="MenuIcon"
                          class="d-block d-lg-none mr-1"
                          size="21"
                          @click="mqShallShowLeftSidebar = true"
                        />
                        <div class="search-results d-block d-lg-none">
                          {{ totalProducts || 0 }} product{{
                            totalProducts > 1 ? 's' : ''
                          }}
                          found
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <!-- Overlay -->
              <div class="body-content-overlay" />

              <!-- Searchbar -->
              <div class="ecommerce-searchbar">
                <b-row class="wishlist-row ml-0 align-items-center">
                  <b-col
                    ref="searchInputBox"
                    class="pl-0 pr-0 col-12 col-md-4 h-100"
                  >
                    <b-input-group class="input-group-merge h-100">
                      <b-form-input
                        v-model="filters.search"
                        v-b-tooltip.hover.bottom="
                          showSearchBarToolTip ? searchBarPlaceholderText : ''
                        "
                        :placeholder="searchBarPlaceholderText"
                        class="search-product pr-3 h-100"
                        @input="searchProducts"
                        @focus="
                          isFocusedSearchBar = true;
                          showSearchBarToolTip = false;
                        "
                        @blur="isFocusedSearchBar = false"
                        @mouseenter="setShowTooltip()"
                      />
                    </b-input-group>
                    <feather-icon
                      icon="SearchIcon"
                      size="18"
                      class="position-absolute search-icon bg-white"
                    />
                  </b-col>
                  <b-col class="pl-0 col-6 col-md-2 h-100">
                    <div
                      v-if="
                        isNotPublicTokenWithRetailer &&
                          wishlist.availableCurrencies.length
                      "
                      class="ml-md-1 mt-1 mt-md-0"
                    >
                      <currency-dropdown
                        :base-currency="wishlistBaseCurrency"
                        :selected-currency="filters.currency"
                        :currencies="wishlist.availableCurrencies || []"
                        @on-selected-currency="filterByCurrency"
                      />
                    </div>
                  </b-col>
                  <b-col
                    class="
                      col-12
                      pt-1 pt-md-0
                      col-md-6
                      d-flex
                      justify-content-end
                      pr-50
                      h-100
                    "
                  >
                    <!-- Select all button -->
                    <div
                      v-if="!publicToken && products.length > 0"
                      class="mr-1"
                    >
                      <select-all-button
                        :is-selected-all="isSelectedAllOnScreen"
                        @toggle-select-all="onToggleSelectAll"
                      />
                    </div>
                    <b-button
                      v-if="isBrand && !isReadOnly"
                      v-b-modal="`modal-share-wishlist-${wishlistId}`"
                      class="mr-1 elements-center py-0 text-nowrap h-100"
                      variant="success"
                      @click="onClickShareWishlist"
                    >
                      <rounded-share-icon class="share-seletion-icon" />
                      Share Wishlist
                    </b-button>
                    <b-button
                      class="custom-icon-btn h-100"
                      :variant="
                        itemViewClass === PRODUCTS_VIEW.GRID_VIEW
                          ? 'outline-info'
                          : 'outline-secondary'
                      "
                      @click="onCompactToggleClick"
                    >
                      <LargeGridViewIcon />
                    </b-button>
                    <b-button
                      class="custom-icon-btn mr-1 h-100"
                      :variant="
                        itemViewClass === PRODUCTS_VIEW.COMPACT_GRID_VIEW
                          ? 'outline-info'
                          : 'outline-secondary'
                      "
                      @click="onCompactToggleClick"
                    >
                      <CompactGridViewIcon />
                    </b-button>
                    <div>
                      <b-dropdown
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        :text="selectedSortBy.text"
                        right
                        variant="outline-primary"
                        class="custom-dropdown-radius h-100"
                      >
                        <b-dropdown-item
                          v-for="sortOption in visibleSortByOptions"
                          :key="sortOption.value"
                          @click="selectedSortBy = sortOption"
                        >
                          {{ sortOption.text }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </b-col>
                </b-row>
                <b-row
                  v-if="!isBrand"
                  class="pl-0 col-12 mx-10-px align-items-center h-100"
                >
                  <span
                    class="color-grey-sult font-size-16-px"
                  >Group Products by:
                  </span>
                  <b-dropdown
                    variant="none"
                    class="group-dropdown"
                    no-caret
                  >
                    <template #button-content>
                      <span class="pr-2-px font-size-16-px">
                        {{ selectedGroup || 'None' }}</span>
                      <feather-icon
                        class="align-middle"
                        icon="ChevronDownIcon"
                        size="16"
                      />
                    </template>
                    <div class="heading">
                      Group By
                    </div>
                    <b-dropdown-item
                      v-for="group in groups"
                      :key="group"
                      :active="selectedGroup === group"
                      @click="selectedGroup = group"
                    >
                      {{ group }}
                    </b-dropdown-item>
                  </b-dropdown>
                </b-row>
              </div>
            </div>

            <!-- Wishlist Products -->
            <div
              v-if="products.length"
              class="shop-height"
              :class="!isBrand && 'wishlist-page'"
            >
              <div
                v-for="(groupedProduct, index) in products"
                :key="index"
              >
                <div
                  v-if="groupedProduct._id && groupedProduct.products.length"
                  class="group-heading wishlist"
                  :style="`z-index :${index + 2}`"
                >
                  <div class="name">
                    {{ groupedProduct._id }}
                  </div>
                </div>
                <section
                  v-if="groupedProduct.products.length"
                  class="wishlist-items"
                  :class="itemViewClass"
                >
                  <!-- has product -->
                  <template>
                    <b-card
                      v-for="product in groupedProduct.products"
                      :key="product.productInfo._id"
                      class="ecommerce-card ecom mb-2"
                      no-body
                    >
                      <span
                        v-if="product.productInfo.keyStyles"
                        class="text-capitalize table-status key-style"
                      >
                        {{ product.productInfo.keyStyles }}
                      </span>
                      <b-form-checkbox
                        v-if="isShowWsp && !isReadOnly && product.productInfo.price !== 'N/A'"
                        :id="product.productInfo._id"
                        :checked="indexes.includes(product.productInfo._id)"
                        class="customCheck"
                        :class="show ? 'showCheckAll' : ''"
                        @change="onCheckboxChange(product, $event)"
                      />

                      <div class="item-img text-center pt-0">
                        <b-link
                          :class="show ? 'pointerevents' : ''"
                          :disabled="!!publicToken"
                          @click="onClickWishlistProduct(product)"
                        >
                          <div class="card-square-image">
                            <b-card-img-lazy
                              class="bg-gray img img-responsive fullwidth"
                              :alt="`${product.productInfo.name}-${product.productInfo._id}`"
                              fluid-grow
                              :src="parseProductImage(product.productInfo)"
                              :class="`img-${product.productInfo._id}`"
                              @load.native="
                                calculateImageRatio(
                                  `img-${product.productInfo._id}`
                                )
                              "
                              @error.native="imageLoadError"
                            />
                            <div class="product-color-wrapper">
                              <div
                                v-if="getHiddenColorCount(product) > 0 && !expandedColorProducts[product._id]"
                                class="product-color-more"
                                @click.stop.prevent="toggleColorExpand(product)"
                              >
                                +{{ getHiddenColorCount(product) }}
                              </div>
                              <div
                                v-if="expandedColorProducts[product._id]"
                                class="product-color-more"
                                @click.stop.prevent="toggleColorExpand(product)"
                              >
                                &minus;
                              </div>
                              <div
                                v-if="expandedColorProducts[product._id] && getHiddenColorCount(product) > 0"
                                class="product-color-remaining"
                              >
                                +{{ getHiddenColorCount(product) }} more
                              </div>
                              <div
                                v-for="(productColor, colorIndex) in getVisibleColors(product)"
                                :key="colorIndex"
                                class="product-color-bg"
                              >
                                <div
                                  v-if="getColorCode(productColor.colorFamily, productColor.hexCode) !== null"
                                  v-b-tooltip.hover.left="productColor.colorNames.join(', ')"
                                  class="product-color"
                                  :class="classForWhiteColor(productColor.colorFamily, productColor.hexCode)"
                                  :style="'background:' + getColorCode(productColor.colorFamily, productColor.hexCode)"
                                />
                                <div
                                  v-else
                                  v-b-tooltip.hover.left="productColor.colorNames.join(', ')"
                                  class="product-color unknown-color"
                                >
                                  /
                                </div>
                              </div>
                            </div>
                          </div>
                        </b-link>
                      </div>

                      <!-- Product Details -->
                      <b-card-body class="card-body-padding">
                        <div class="product-name item-name d-flex">
                          <b-link
                            :id="`tooltip_w_product_name_${product.productInfo._id}`"
                            :class="show ? 'pointerevents' : ''"
                            class="text-left item-name pr-2"
                            :disabled="!!publicToken"
                            :to="{
                              name: 'product-detail',
                              params: {
                                id: product.productInfo._id,
                                collectionId: product.productInfo.collectionId,
                              },
                            }"
                            @mouseover="
                              showTooltip(
                                `tooltip_w_product_name_${product.productInfo._id}`,
                                product.productInfo._id
                              )
                            "
                          >
                            {{ product.productInfo.name }}
                          </b-link>
                          <b-tooltip
                            v-if="product.productInfo._id === tooltipId"
                            class="font-Inter"
                            :target="`tooltip_w_product_name_${product.productInfo._id}`"
                            placement="bottom"
                            triggers="hover"
                          >
                            {{ product.productInfo.name }}
                          </b-tooltip>
                        </div>
                        <div
                          class="
                            d-flex
                            mb-5-px
                            flex-wrap
                            justify-content-between
                          "
                        >
                          <b-card-text class="product-style-code">
                            <span class="style-code">Style Code:</span>
                            {{ product.productInfo.styleCode }}
                          </b-card-text>
                        </div>
                        <div
                          class="
                            d-flex
                            justify-content-between
                            flex-wrap
                            text-nowrap
                          "
                        >
                          <b-card-text
                            v-if="
                              isShowWsp
                                && wspAllowedForViewer
                                && hasWholesalePriceFor(product.productInfo)
                            "
                            class="product-price d-flex flex-wrap"
                          >
                            WSP:
                            <span
                              v-if="!product.productInfo.discountedPrice"
                              :class="{
                                'text-line-through':
                                  product.productInfo.discountedPrice,
                              }"
                            >
                              {{
                                formatCurrency(
                                  listWholesalePriceOf(product.productInfo),
                                  product.productInfo.currency
                                )
                              }}
                            </span>
                            <span
                              v-if="product.productInfo.discountedPrice"
                              class="discounted-price"
                            >
                              {{
                                formatCurrency(
                                  product.productInfo.discountedPrice,
                                  product.productInfo.currency
                                )
                              }}
                            </span>
                          </b-card-text>
                          <b-card-text
                            class="
                              product-price-rrp product-price-rrp-public
                              mb-0
                            "
                          >
                            RRP:
                            {{
                              formatCurrency(
                                product.productInfo.retailPrice,
                                product.productInfo.currency
                              )
                            }}
                          </b-card-text>
                          <span
                            v-if="product.productInfo.quantityAvailable !== undefined && product.productInfo.quantityAvailable !== null"
                            class="stock-badge-inline"
                            :class="product.productInfo.quantityAvailable === 0 ? 'out-of-stock' : 'in-stock'"
                          >
                            <feather-icon
                              icon="PackageIcon"
                              size="13"
                            />
                            <span v-if="product.productInfo.quantityAvailable === 0">OOS</span>
                            <span v-else>{{ product.productInfo.quantityAvailable }}</span>
                          </span>
                        </div>
                      </b-card-body>

                      <!-- Action Buttons -->
                      <div
                        v-if="isShowWsp && !isReadOnly"
                        class="item-options flex-wrap text-center"
                      >
                        <b-button
                          :class="show ? 'pointerevents' : ''"
                          variant="light"
                          class="btn-wishlist remove-wishlist"
                          @click="removeProductFromWishlistClick(product)"
                        >
                          <feather-icon
                            icon="XIcon"
                            size="18"
                          />
                          <span>Remove</span>
                        </b-button>
                        <b-button
                          v-if="isNotPublicTokenWithRetailer"
                          v-b-tooltip.hover.bottom="product.productInfo.price === 'N/A' ? 'Price not available. Please contact your brand.' : ''"
                          :class="show ? 'pointerevents' : ''"
                          variant="none"
                          class="btn-cart button-cart move-cart text-nowrap"
                          :disabled="product.productInfo.price === 'N/A'"
                          @click="
                            handleWishlistCartActionClick(product, wishlistId)
                          "
                        >
                          <feather-icon
                            icon="ShoppingCartIcon"
                            class="mr-50"
                            size="18"
                          />
                          <span class="compact-view-cart-text">{{
                            isProductInCart(product) ? 'In Cart' : ''
                          }}</span>
                          <span class="large-view-cart-text">
                            {{
                              isProductInCart(product)
                                ? 'View In Cart'
                                : 'Move to Cart'
                            }}</span>
                        </b-button>
                      </div>
                    </b-card>
                  </template>
                </section>
              </div>
              <section
                v-if="continueLoading"
                class="mt-4"
              >
                <b-row>
                  <b-col
                    cols="12"
                    class="text-center"
                  >
                    <b-spinner
                      ref="loadingIcon"
                      class="loading-icon"
                      label="Loading..."
                    />
                  </b-col>
                </b-row>
              </section>
            </div>
            <div v-else>
              <empty-products-message v-if="filters.search" />
            </div>
          </div>
        </template>
        <template v-else>
          <b-card
            title="No Products Added"
            class="w-100"
          >
            <b-card-text>
              Go to "{{
                isNotPublicTokenWithRetailer ? 'Explore' : 'Collections'
              }}" and start adding some products to your Amazing
              {{ getWishlistTitle() }}
            </b-card-text>
            <div class="d-flex">
              <div id="explore_button">
                <b-button
                  class="explore-now"
                  :to="
                    isNotPublicTokenWithRetailer
                      ? { name: 'explore' }
                      : { name: 'collections' }
                  "
                  variant="primary"
                  :disabled="
                    isNotPublicTokenWithRetailer && !isEnabledMarketplace
                  "
                >
                  {{
                    isNotPublicTokenWithRetailer ? 'Explore Now' : 'Collections'
                  }}
                </b-button>
              </div>
            </div>
            <b-tooltip
              v-if="isNotPublicTokenWithRetailer && !isEnabledMarketplace"
              target="explore_button"
              placement="bottom"
            >
              {{ marketplaceAccessDeniedMessage }}
            </b-tooltip>
          </b-card>
        </template>
      </div>
      <tool-kit :toolkit-page="TOOLKIT_PAGE.WISHLIST" />
    </div>
    <div
      v-else-if="error"
      class="d-flex justify-content-center align-items-center"
    >
      <b-card class="w-100 p-3 elements-center text-center">
        <b-card-text>
          <h3 class="error-text">
            {{ error }}
          </h3>
        </b-card-text>
      </b-card>
    </div>
    <b-card
      v-else
      class="p-3 elements-center"
    >
      <b-spinner />
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardImgLazy,
  BCardText,
  BLink,
  BButton,
  BFormCheckbox,
  BSpinner,
  BRow,
  BCol,
  BInputGroup,
  BFormInput,
  VBTooltip,
  BTooltip,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import { getColorCode, classForWhiteColor } from '@/product-colors'
import {
  formatObject,
  getDefaultProductPlaceholderImage,
  getWishlistTitle,
  isEllipsisActive,
} from '@core/utils/utils'
import store from '@/store'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import analytics, {
  getSelectionOrWishlistMixpanelObj,
} from '@/@core/utils/analytics'
import constants, {
  TOOLKIT_PAGE,
  wishlistAction,
  PRODUCTS_VIEW,
  marketplaceAccessDeniedMessage,
  DOWNLOAD_TYPES,
  FILE_FORMATS,
  MAX_COLORS_PER_PRODUCT_CARD,
  MAX_COLORS_EXPANDED,
} from '@/constants'
import LargeGridViewIcon from '@/@core/assets/svg-components/LargeGridViewIcon.vue'
import { hasWholesalePriceFor, listWholesalePriceOf } from '@/utils/productPricing'
import CompactGridViewIcon from '@/@core/assets/svg-components/CompactGridViewIcon.vue'
import {
  UPDATE_IS_SELECTED_ALL_PRODUCTS,
  UPDATE_SELECT_COUNT,
  UPDATE_SELECT_TYPE,
  MULTI_SELECT_PAGES,
} from '@/store/modules/shop.module'
import RoundedShareIcon from '@/@core/assets/svg-components/RoundedShareIcon.vue'
import ProductImageMixin from '@/views/mixins/ProductImageMixin.vue'
import { mapState } from 'vuex'
import { DOWNLOAD_COLLECTION } from '@/store/modules/collection.module'
import Ripple from 'vue-ripple-directive'
import CurrencyDropdown from '@/views/components/currency-dropdown/CurrencyDropdown.vue'
import { SHOW_DOWNLOADS_NAV_INDICATOR } from '@/store/modules/notification.module'
import SelectAllButton from '@/views/components/select-all-btn/SelectAllButton.vue'
import { apiToastSuccess } from '@core/utils/toast'
import { constants as c } from '@kingpin-global/kingpin-utils-frontend'
import {
  useWishlistProducts, sortByOptions, sortOptionsFor, searchBarPlaceholderText,
} from '@/composables/useWishlistProducts'
import ShopFilter from '../shop/ShopFilter.vue'
import EmptyProductsMessage from '../shop/EmptyProductsMessage.vue'
import UserRoleMixin from '../UserRoleMixin.vue'
import ShopMixin from '../shop/ShopMixin.vue'

const { BRAND_ACCESS } = c
const { CONNECTION_REQUEST_STATUS, TRACKS } = constants
const { MULTI_SELECT_PRODUCTS } = TRACKS.ACTIONS

export default {
  name: 'Wishlist',
  components: {
    BCard,
    BCardBody,
    BCardImgLazy,
    BCardText,
    BLink,
    BButton,
    BFormCheckbox,
    BRow,
    BCol,
    BInputGroup,
    BFormInput,
    BTooltip,
    BDropdown,
    BDropdownItem,
    BSpinner,
    ShopFilter,
    FeatherIcon,
    EmptyProductsMessage,
    LargeGridViewIcon,
    CompactGridViewIcon,
    RoundedShareIcon,
    CurrencyDropdown,
    SelectAllButton,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  mixins: [UserRoleMixin, ProductImageMixin, ShopMixin],
  props: {
    select: Boolean,
    publicToken: {
      type: String,
      default: null,
    },
  },
  setup(props, { root }) {
    const wp = useWishlistProducts(props, root)
    return {
      ...wp,
      notFoundImg: require('@/assets/images/pages/error.svg'),
    }
  },
  data() {
    return {
      groupIndexes: [],
      selectall: 'false',
      tooltipId: '',
      getDefaultProductPlaceholderImage,
      TOOLKIT_PAGE,
      getColorCode,
      classForWhiteColor,
      getWishlistTitle,
      PRODUCTS_VIEW,
      itemViewClass: PRODUCTS_VIEW.GRID_VIEW,
      marketplaceAccessDeniedMessage,
      sortByOptions,
      selectedSortBy: sortByOptions[0],
      searchBarPlaceholderText,
      showSearchBarToolTip: true,
      isFocusedSearchBar: false,
      updatedProductsIdsSet: new Set(),
      expandedColorProducts: {},
    }
  },
  computed: {
    // KP-4586: no price sort on a public link priced from a chosen book.
    visibleSortByOptions() {
      return sortOptionsFor(this.sortByOptions, this.hasPriceSource)
    },
    isNotPublicTokenWithRetailer() {
      return !this.publicToken && this.isRetailer
    },
    hasFilterOptions() {
      return Object.keys(this.filterOptions)?.length > 2
    },
    isShowWsp() {
      return !(
        this.isWspHidden
        && this.requestStatus !== CONNECTION_REQUEST_STATUS.APPROVED
      )
    },
    ...mapState({
      profile: state => state.auth.profileData,
    }),
    isEnabledMarketplace() {
      return this.profile?.access?.includes(BRAND_ACCESS.MARKETPLACE)
    },
    fetchedProductsIdsSet() {
      const productsIdsSet = new Set()
      if (!this.products) return productsIdsSet
      this.products.forEach(groupedProduct => {
        groupedProduct.products.forEach(product => {
          productsIdsSet.add(product.productId)
        })
      })
      return productsIdsSet
    },
    productList() {
      return this.products.flatMap(groupIndex => groupIndex.products.filter(product => this.indexes.includes(product.productInfo._id)))
    },
    show() {
      return this.indexes.length > 0
    },
  },
  watch: {
    selectedSortBy() {
      let sort = this.selectedSortBy.value

      if (this.publicToken && sort === 'highest') {
        sort = 'highest_retail'
      }

      if (this.publicToken && sort === 'lowest') {
        sort = 'lowest_retail'
      }

      if (this.publicToken) {
        this.filters.sort = sort
      } else {
        this.filters.sortBy = sort
      }

      this.fetchShopProducts()
    },
    indexes() {
      this.groupIndexes = this.products.flatMap((group, groupIndex) => group.products
          .filter(product => this.indexes.includes(product.productInfo._id))
          .map(product => ({
            groupIndex,
            productId: product.productInfo._id,
          })))
    },
  },
  created() {
    this.$root.$refs.wishlist = this
    store.commit(UPDATE_SELECT_TYPE, MULTI_SELECT_PAGES.WISHLIST)
    this.filters.sort = this.selectedSortBy.value
    this.fetchShopProducts()
  },
  destroyed() {
    store.commit(UPDATE_SELECT_COUNT, 0)
    store.commit(UPDATE_IS_SELECTED_ALL_PRODUCTS, false)
    analytics.track(
      this.isBrand
        ? constants.TRACKS.ACTIONS.BRAND_END_VIEWING_SELECTION
        : constants.TRACKS.ACTIONS.RETAILER_END_VIEWING_WISHLIST,
      formatObject(
        getSelectionOrWishlistMixpanelObj(this.wishlist, this.isBrand),
      ),
    )
  },
  methods: {
    hasWholesalePriceFor,
    listWholesalePriceOf,

    getVisibleColors(product) {
      const max = this.expandedColorProducts[product._id] ? MAX_COLORS_EXPANDED : MAX_COLORS_PER_PRODUCT_CARD
      return (product.colors || []).slice(0, max)
    },
    getHiddenColorCount(product) {
      const total = (product.colors || []).length
      if (this.expandedColorProducts[product._id]) return Math.max(0, total - MAX_COLORS_EXPANDED)
      return Math.max(0, total - MAX_COLORS_PER_PRODUCT_CARD)
    },
    toggleColorExpand(product) {
      this.$set(this.expandedColorProducts, product._id, !this.expandedColorProducts[product._id])
    },
    onCheckboxChange(product, isChecked) {
      const productId = product.productInfo._id

      if (isChecked) {
        if (!this.indexes.includes(productId)) {
          this.indexes = [...this.indexes, productId]
          analytics.track(
            MULTI_SELECT_PRODUCTS.USER_SELECTS_PRODUCT_BY_CHECKBOX_IN_WISHLIST_PRODUCTS_PAGE,
            {
              product,
            },
          )
        }
      } else {
        this.indexes = this.indexes.filter(id => id !== productId)
        analytics.track(
          MULTI_SELECT_PRODUCTS.USER_DESELECTS_PRODUCT_BY_CHECKBOX_IN_WISHLIST_PRODUCTS_PAGE,
          {
            product,
          },
        )
      }
    },
    onClickShareWishlist() {
      this.$bvModal.show(`modal-share-wishlist-${this.wishlistId}`)
      analytics.track(
        constants.TRACKS.ACTIONS.BRAND_OPENS_SHARE_SELECTION_POPUP,
        { wishlist: this.wishlist },
      )
    },
    isProductInCart(product = null) {
      return product?.isInCart || product?.productInfo?.isInCart
    },
    async downloadSelectedWishlistProducts() {
      try {
        const payload = {
          downloadType: DOWNLOAD_TYPES.COLLECTION_EXPORT.VALUE,
          respectiveId: this.collectionId,
          fileType: FILE_FORMATS.XLSX,
          productIds: this.indexes,
        }
        const params = {
          isOrderSheetDownload: true,
        }
        const res = await this.$store.dispatch(DOWNLOAD_COLLECTION, {
          payload,
          params,
        })
        apiToastSuccess(res.data.message)
        this.$store.commit(SHOW_DOWNLOADS_NAV_INDICATOR)
        this.unSelectAll()
      } catch (err) {
        // error toast handled by axios interceptor
      }
    },
    onClickWishlistProduct(product) {
      this.$router.push({
        name: 'product-detail',
        params: {
          id: product.productInfo._id,
          collectionId: product.productInfo.collectionId,
        },
      })
      analytics.track(
        constants.TRACKS.PAGES.RETAILER_OPENS_WISHLIST_PRODUCT,
        formatObject(getSelectionOrWishlistMixpanelObj(product, false)),
      )
    },
    showTooltip(id, productId) {
      const productNameElement = document.getElementById(id)
      if (productNameElement && isEllipsisActive(productNameElement)) {
        this.tooltipId = productId
      }
    },
    onCompactToggleClick() {
      if (this.itemViewClass === PRODUCTS_VIEW.GRID_VIEW) {
        this.itemViewClass = PRODUCTS_VIEW.COMPACT_GRID_VIEW
      } else {
        this.itemViewClass = PRODUCTS_VIEW.GRID_VIEW
      }
    },
    async removeAllFromWishList() {
      const action = wishlistAction.REMOVE_IN_WISHLIST
      await this.reactToggleProductInWishlist(
        this.productList,
        this.indexes,
        action,
      )
      this.unSelectAll()
    },
    moveAllToCart() {
      this.addMultipleItemsCartActionClick({
        product: this.productList,
        indexes: this.indexes,
      })
      this.unSelectAll()
    },
    unSelectAll() {
      this.forceToggleSelect(false)
    },
    setShowTooltip() {
      if (!this.isFocusedSearchBar) {
        this.showSearchBarToolTip = true
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/base/pages/app-ecommerce.scss';
@import '~@core/scss/base/pages/app-shop.scss';

.content.app-content {
  padding: calc(2rem + 4.45rem + 1.3rem) 1rem 0;
}

.error-text {
  color: $danger;
  font-size: 2rem;
}

.item-options button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: auto;
}

.unknown-color {
  background: #C0C0C0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  color: #666;
  border: 1px solid #ccc;
}

.product-color-more {
  font-size: 11px;
  color: #666;
  display: flex;
  align-items: center;
  margin-left: 2px;
}
.product-color-remaining {
  font-size: 10px;
  color: #999;
  text-align: center;
  margin-top: 2px;
}
</style>
